import angular from 'angular';

angular
  .module('cloudX')
  .controller('TaskScheduleDeviationsDialogCtrl', [
    'flySvc',
    '$element',
    'close',
    'schedule',
    '$http',
    'appUrls',
    'dataCache',
    'enumCacheSvc',
    'translateListFilter',
    '$translate',
    taskScheduleDeviationsDialogCtrl,
  ]);

function taskScheduleDeviationsDialogCtrl(
  flySvc,
  $element,
  close,
  schedule,
  $http,
  appUrls,
  dataCache,
  enumCacheSvc,
  translateListFilter,
  $translate,
) {
  var vm = this;
  vm.deviations = null;
  vm.mainTaskDeviation = null;
  vm.schedule = schedule;
  vm.loading = true;
  vm.propagate = true;

  dataCache.ready().then(function() {
    const users = dataCache.getArray('user');

    vm.users = users
      .filter(x => x.isActive || !x.hidden)
      .map(function(user) {
        return {
          id: user.userID,
          label: `${user.firstName} ${user.lastName}`,
          isActive: user.isActive,
        };
      })
      .sortByProperty('name');
    enumCacheSvc.get('employeeprofile').then(function(data) {
      vm.profiles = data.map(({ key, value }) => ({
        id: key,
        value,
        label: translateListFilter(key, 'employeeprofile', value),
      }));
    });
  });
  function translateProfiles() {
    vm.profiles.forEach(p => {
      p.label = translateListFilter(p.id, 'employeeprofile', p.value);
    });
  }
  enumCacheSvc.get('employeeprofile').then(function(data) {
    vm.profiles = data.map(({ key, value }) => ({ id: key, value, label: value }));
    translateProfiles();
  });
  vm.getProfileLabel = function(profile) {
    if (!profile) return null;
    const prof = vm.profiles.find(p => p.id === profile);
    vm.showWarning = false;
    return prof ? prof.label : '/';
  };
  vm.translateTemplateAssignedType = deviation => {
    if (!deviation.templateAssignedType)
      return deviation.isMainTaskDeviation
        ? $translate.instant('Unassigned').toLowerCase()
        : $translate.instant('Use assigned user of main task').toLowerCase();
    if (deviation.templateAssignedType === 1)
      return vm.getProfileLabel(deviation.templateAssignedProfile).toLowerCase();
    if (deviation.templateAssignedType === 2)
      return vm.getUserName(deviation.templateAssignedUserId);
    return $translate.instant('Unassigned').toLowerCase();
  };

  vm.getUserName = function(userId) {
    if (!userId) return null;
    const user = vm.users.find(u => u.id === userId);
    return user ? user.label : '/';
  };

  $http.get(`${appUrls.tasks}/api/TaskSchedules/${schedule.id}/deviations`).then(
    function({ data }) {
      vm.deviations = data
        .filter(x => !x.isMainTaskDeviation)
        .map(x => {
          return {
            ...x,
            assignedTo: {
              assignedType: x.assignedType,
              userId: x.assignedUserId,
              profile: x.assignedProfile,
            },
          };
        });
      vm.mainTaskDeviation = data.find(x => x.isMainTaskDeviation) ?? {
        isMainTaskDeviation: true,
        taskScheduleId: vm.schedule.id,
      };
      vm.mainTaskDeviation.assignedTo = {
        assignedType: vm.mainTaskDeviation.assignedType,
        userId: vm.mainTaskDeviation.assignedUserId,
        profile: vm.mainTaskDeviation.assignedProfile,
      };

      vm.loading = false;
    },
    function(error) {
      vm.loading = false;
      showError(error);
    },
  );

  vm.assignedToChanged = function(deviation) {
    deviation.assignedType = deviation.assignedTo.assignedType;
    deviation.assignedUserId = deviation.assignedTo.userId;
    deviation.assignedProfile = deviation.assignedTo.profile;
  };

  vm.executionDurationChanged = function(deviation) {};

  vm.save = function() {
    const model = angular.copy([vm.mainTaskDeviation, ...vm.deviations]);
    vm.saving = true;
    $http
      .put(`${appUrls.tasks}/api/TaskSchedules/${schedule.id}/deviations/${vm.propagate}`, model)
      .then(
        ({ data }) => {
          vm.saving = false;
          flySvc.changesSaved();
          $element.modal('hide');
          close(null, 500);
        },
        error => {
          flySvc.error(error);
          vm.saving = false;
        },
      );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
